import { Interface } from "readline";
import * as api from "./api";
import * as clsApi from "../api/classroomApi";
import { List } from "lodash";
import { useSelectedClassroomStore } from "stores/v2/selectedClassroomStore";
import { useUserSessionStore } from "stores/v2/userSessionStore";

export interface EventsServiceUrlResponse {
	result: string;
}

export async function getEventServiceUrl(): Promise<string> {
	const res = (await api.get("/backend/events/get/url")) as EventsServiceUrlResponse;
	return res.result;
}

export interface SendAnnouncementRequest {
	classroomSourceId: string;
	classroomId: string;
	message: string;
	recipients: List<string> | undefined;
}

export interface SendOpenTabRequestBatch {
	requests: List<OpenTabEvent>;
}

export interface OpenTabEvent {
	recipients: List<string>;
	event_object: {
		url: string;
	};
}

export interface SendClassStartedEventRequest {
	recipient: string;
}

export interface SendAnnouncementResponse {
	result: Interface;
}

export interface EventServiceResponse {
	error: string;
}

export async function sendAnnouncement(
	classroomSourceId: string,
	classroomId: string,
	message: string,
	recipients: List<string>
): Promise<SendAnnouncementResponse> {
	const payload: SendAnnouncementRequest = {
		classroomSourceId: classroomSourceId,
		classroomId: classroomId,
		message: message,
		recipients: recipients,
	};
	return await clsApi.Post<SendAnnouncementRequest, SendAnnouncementResponse>("events/announcement", payload);
}

export async function sendOpenTabBatch(requests: OpenTabEvent[]): Promise<EventServiceResponse> {
	const applianceId = localStorage.getItem("DEVICE") as string;
	const classroomSourceId = useUserSessionStore.getState().getActiveGroup();
	const classroomId = useSelectedClassroomStore.getState().id;
	const payload = {
		classroom_source_id: classroomSourceId,
		classroom_id: classroomId,
		requests: requests,
	};
	return await clsApi.Post2<SendOpenTabRequestBatch, EventServiceResponse>(`v1/appliances/${applianceId}/events/open-tabs`, payload);
}

export async function sendTargetedClassStartedEvent(recipient: string): Promise<EventServiceResponse> {
	const applianceId = localStorage.getItem("DEVICE") as string;
	const payload = {
		recipient: recipient,
	};
	return await clsApi.Post2<SendClassStartedEventRequest, EventServiceResponse>(
		`v1/appliances/${applianceId}/events/class-started`,
		payload
	);
}
